/**
 * 基础菜单 商品管理
 */
<template>
  <div style="background:;">
   
    <!-- 面包屑导航 -->
    <div class="separators">
      <span style="font-size: 25px; position: absolute; top: 30px; left: 30px;" >活动流程：发布活动>报名活动>参加活动（现场核销）>活动结束（完成）</span>
        <el-button @click="goBack(1)" type="primary" round style="margin-top: 25px; margin-right: 50px; float: right;">返回上一页</el-button>
<el-button @click="goBack(2)" round  type="success"   style="margin-top: 25px; margin-right: 20px; float: right;">已报名群发系统通知</el-button>
<el-button  v-if="userDetail.status!=5" @click="goBack(3)" round  type="success"   style="margin-top: 25px; margin-right: 20px; float: right;">编辑活动</el-button>
<el-button v-if="userDetail.status==5" disabled  round  type="info"   style="margin-top: 25px; margin-right: 20px; float: right;">编辑活动</el-button>
<el-button v-if="roleId.roleId==1||roleId.roleId==2" @click="dialogVisibles" round  type="primary"   style="margin-top: 25px; margin-right: 20px; float: right;">导出报名</el-button>
    </div>
<div>

    <el-descriptions class="margin-top" title="活动详情" :column="4" style="width: 100%; font-size: 20px;"  border>
    <template slot="extra">
    
    </template>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-user"></i>
        活动卡片标签
      </template>
      <el-tag v-if="userDetail.cost== 0" type="primary" disable-transitions>免费活动</el-tag>
          <el-tag v-if="userDetail.cost > 0" type="success" disable-transitions>精选活动</el-tag><br>

    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-mobile-phone"></i>
        活动ID
      </template>
      {{ userDetail.id }}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-location-outline"></i>
        活动标题
      </template>
     {{ userDetail.title }}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-tickets"></i>
        活动详情标签：
      </template>
      <div v-for="item in  userDetail.label">
        <el-tag size="small">{{ item }}</el-tag>

    </div> 
      
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        活动封面：
      </template>

      <el-image style="width: 120px; height: 120px;" :src="userDetail.image" :preview-src-list="[userDetail.image]" />
      <!-- <img style="width: ; height: ;" :src="userDetail.image" alt=""> -->
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        名额总数
      </template>
    <span>{{ userDetail.enrollment }}人 &nbsp;&nbsp;&nbsp;&nbsp;已报名:{{userDetail.joinCount}}人</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        报名费用
      </template>
    <span>¥{{ userDetail.cost }}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        活动地点
      </template>
    <span>{{ userDetail.activityAddress }}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        活动详细地址
      </template>
      <span>{{ userDetail.activityDetailAddress }}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        联系电话
      </template>
      <span>{{ userDetail.telephone }}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        截止时间
      </template>
      
    <span>{{ userDetail.closeTimeMills| timestampToTime}}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        活动开始时间
      </template>
      <span>{{ userDetail.beginTimeMills| timestampToTime}}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        活动结束时间
      </template>
      <span>{{ userDetail.endTimeMills| timestampToTime}}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        发布时间
      </template>
      <span>{{ userDetail.createTimeMills| timestampToTime}}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        是否推荐
      </template>
      <span>{{ userDetail.indexDesc }}</span>

    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        活动状态
      </template>
      <div v-if="userDetail.status == 1" style="color: #34D0B4;">报名中</div>
          <div v-if="userDetail.status == 2" style="color: #CF1F1F;">已满员</div>
          <div v-if="userDetail.status == 3" style="color: #CF1F1F;">报名截止</div>
          <div v-if="userDetail.status == 4" style="color: #F9AD00;">活动开始</div>
          <div v-if="userDetail.status == 5" style="color: #CF1F1F;">活动结束</div>
    </el-descriptions-item>



    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        展示平台
      </template>
      <div  style="color: #F9AD00;" >{{ userDetail.platformTypeDesc }} </div>
    </el-descriptions-item>
   

    <!-- <el-table-column  prop="platformType"  align="center" label="展示平台" width="150">
        <template slot-scope="scope">
       
      </template>
    </el-table-column> -->
  </el-descriptions>
</div>

 
 
     


<el-dialog title="已报名群发系统消息" :visible.sync="Systemmessages"  width="70%" >

  <el-descriptions class="margin-top" title="" :column="2" style="width: 100%; font-size: 20px;"  border>
    <template slot="extra">
    
    </template>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-location-outline"></i>
        活动标题
      </template>
     {{ userDetail.title }}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-mobile-phone"></i>
        活动ID
      </template>
      {{ userDetail.id }}
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
      开始时间
      </template>
      <span>{{ userDetail.beginTimeMills| timestampToTime}}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        结束时间
      </template>
      <span>{{ userDetail.endTimeMills| timestampToTime}}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        活动地点
      </template>
    <span>{{ userDetail.activityAddress }}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        活动详细地址
      </template>
      <span>{{ userDetail.activityDetailAddress }}</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        名额总数
      </template>
    <span>{{ userDetail.enrollment }}人</span>
    </el-descriptions-item>
    <el-descriptions-item>
      <template slot="label">
        <i class="el-icon-office-building"></i>
        名额人数
      </template>
    <span>男会员:{{ userDetail.manJoinCount }}人 
     </span><br>
     <span>女会员:{{ userDetail.woManJoinCount }}人</span>
    </el-descriptions-item>
    
  </el-descriptions>
  <el-form :rules="rules" ref="formRoList" style="margin-top: 30px;" :model="formRoList" >
    <el-form-item prop="useStatus" label="会员状态">
        <el-select v-model="formRoList.useStatus" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="未签到" value="1"></el-option>
          <el-option label="已签到" value="2"></el-option>
          <el-option label="已退款" value="3"></el-option>
          <el-option label="已过期" value="4"></el-option>
          <el-option label="已失效" value="5"></el-option>
        </el-select>
      </el-form-item>
    <el-form-item style="width: 700px; margin-left: -10px;" prop="content"  label="通知内容" :label-width="formLabelWidth">
      <el-input
  type="textarea"
  placeholder="例如：您报名了七夕旅游活动相亲活动，请携带身份证准时参加。"
  v-model="formRoList.content"
  maxlength="500"
  show-word-limit
>
</el-input>
    </el-form-item>
    
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="Systemmessages = false">取 消</el-button>
    <el-button type="primary" @click="submitForm('formRoList')">确定群发站内信</el-button>
  </div>
</el-dialog>

  </div>
  
</template>

<script>

import Axios from 'axios'

import Vue from 'vue'

import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      ssoServer:"",
      roleId:"",
      formRoList:{
        content:'',
        useStatus:"",
        activityId:""

      },
      dialogFormVisible:false,
      options1234123:[],
      Systemmessages:false,
      userDetail:"",
      form:{},
      adder:"",
      testOccupation:[],
      srcList: [
        ],
      listData:"",
   
      formLIst:{
        sex:"",
        expectMarryTime:"",
        education:"",
        isHaveChildren:"",
        birthday:'',
        height:"",
        weight:"",
        maritalStatus:"",
        id:"",
        monthlyIncome:"",
        nationality:"",
        
        registerAddress:"",
        registerIpAddress:"",

        occupation:""
      

      },
      formLabelWidth: '80px',
      rules: {
        content: [
            { required: true, message: '通知内容不能为空', trigger: 'blur' },
           
          ],
          
        }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.roleId=JSON.parse(localStorage.getItem('userlist'))
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    let tokenId= localStorage.getItem('tokenId');
    this.adder =tokenId

    
    // this.formLIst.sex=男
 

    // this.getdata(this.formInline)
  },
   mounted(){
   
   



   this.addrde()


   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {


    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
        
            const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
          Axios({
        method: 'post',
        url: this.ssoServer+'//api/activity/sendCustomSysNotice',
        headers:{
    tokenId:this.adder
        },
        data:this.formRoList
      }).then(res => {
        if(res.data.code==0){
          this.Systemmessages=false
          this.$message({
          message: '发送成功',
          type: 'success'
        });
        this.formRoList.useStatus=''
        this.formRoList.content=''

        }else{
          this.$message({
          message: res.data.message,
          type: 'warning'
        });

        }
        // console.log(res);
        // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })
      
        }, 500);
      


         




            // alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },


    dialogVisibles(){
      Axios({
  method: 'post',

  url: this.ssoServer+'//api/activity/exportJoinAccount',
  headers:{
    tokenId:this.adder
        },
  data: {
    activityId:this.userDetail.id
  },
  responseType: 'blob'
}).then(res => {
  const link = document.createElement('a') // 创建a标签
  const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
  link.href = window.URL.createObjectURL(blob)
  const filename = '用户列表'
  link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
  link.click()
  window.URL.revokeObjectURL(link.href)
})
// this.dialogVisible=false
    },
 



    addrde(){
      
    this.getAddresss()
    Axios({
  method: 'get',

  url: this.ssoServer+'/api/activity/getActivityDetail',
  headers:{
    tokenId:this.adder
        },
  params:{
    id: this.$route.query.id
  }
    
}).then(res=>{
  this.formRoList.activityId=res.data.data.id
  
  
  
  this.userDetail =res.data.data

  
  
  
  
  // this.formLIst=res.data.data
      
  console.log(res);
})


    },
    dialogFormVisibleSle(){
      Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-account/edit',
        headers:{
    tokenId:this.adder
        },
        data:this.formLIst
        
      }).then(res => {
        if(res.data.code==0){
          this.dialogFormVisible=false
          this.$message({
          message: '编辑成功',
          type: 'success'
        });
        this.addrde()

        }
        console.log(res);
        // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })

      



    console.log(this.formLIst);
    },
    onChanges(e){
                this.formLIst.registerAddress=e[1]
                  // console.log( this.formInline.registerAddress);
              },
    getAddresss(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
    tokenId:this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    Clickbutton(id){
      this.dialogFormVisible=true
    

    },
    goBack(e){
        if(e==1){
            this.$router.push({
    path:"/Eventmanagement/activities",
    
})
        }else if(e==3){
          this.$router.push({
    path:"/Eventmanagement/addActivities",
    query:{ //query是个配置项
      id:this.$route.query.id
    }
    
})


        }else if(e==2){
          this.Systemmessages=true
          console.log('1111');
      
    }
    

    },
    // adder(){
    //  this.srcList = this.listData.headIcon
    // },
    handleClose(){

    },

    selectalls(rows){
      // console.log(row);
              //  return console.log("rows : "+JSON.stringify(rows));
                if(rows){
                  rows.forEach(row =>{
                    this.$refs.multipleTable.toggleRowSelection(row);
                  });
                }else{
                    this.$refs.multipleTable.clearSelection();//清除全选
                }
              },


   
    selectall(val){
      this.importList
    console.log(val);
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    // 导出数据
    imporList(){
      this.dialogVisible=true
    },
    select(selection, row){
      selection.forEach((item)=>{
      
        this.importList=item.id
        // console.log(this.importList);

      })
      
     ;
    },
    resetForm(formInline) {
  //  this.formInline =''
        this.$refs[formInline].resetFields();
      },


   
    // formatData(row, column, cellValue, index){
		
		// //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		// //最终返回 s 就可以了
		// var s =	new Date(cellValue).toLocaleString();
	  //   return s;

		//   // 测试参数含义：不知道参数是什么含义的就打印出来
		//   // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		//   // console.log(column)  	//拿到列的信息
		//   // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		//   // console.log(index)     //拿到索引
	  //   },

    // 获取公司列表
   
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
this.formLIst()
      
      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
  

  }
}
</script>


<style scoped >
.separators{
  width: 100%;
 height: 100px;
  background-color:#F3F8FA;
  /* margin-top: 30px; */
  position: relative;


}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/Eventmanagement/activitiesDetail.vue